import { render, staticRenderFns } from "./affiliate-commissions.vue?vue&type=template&id=4319586e"
import script from "./affiliate-commissions.vue?vue&type=script&lang=js"
export * from "./affiliate-commissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports